import {getComparableTemplateName} from 'lib/ReportUtil';
import get from 'lodash/get';

export const makeComparableItemMapSection = (s, reportType) => {
  let templateVersion = 4;
  const template = getComparableTemplateName(s.key, templateVersion);
  return {
    name: s.key,
    title: get(s, 'sectionData.title'),
    pdf: s.url,
    template,
    data: {
      ...s.sectionData,
    }
  };
};